import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import { Delete, Edit, Groups2Outlined } from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import FlexBetween from "components/FlexBetween";
import moment from "moment";
import "moment/locale/id";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import {
  fetchAddPanduan,
  fetchDeletePanduan,
  fetchEditPanduan,
  fetchListPanduan,
} from "state/panduanActions";
import AddPanduanModal from "components/Modals/AddPanduanModal";
import { BASEURL } from "api/axiosInstance";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import EditPanduanModal from "components/Modals/EditPanduanModal";
moment.locale("id");

const Panduan = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [openAdd, setOpenAdd] = useState(false);
  const [openKonfirmasi, setOpenKonfirmasi] = useState(false);
  const [openModalEditPanduan, setOpenModalEditPanduan] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  const [selectedData, setSelectedData] = useState(null);

  const { status, message } = useSelector((state) => state.global);
  const { list_panduan } = useSelector((state) => state.panduan);

  useEffect(() => {
    dispatch(fetchListPanduan());
  }, []);

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListPanduan());
  };

  const handleSubmitPanduan = (value) => {
    dispatch(fetchAddPanduan(value));
  };
  const handleSubmitEditPanduan = (value) => {
    const reqData = {
      id: selectedData.id,
      nama_sop: value,
    };

    dispatch(fetchEditPanduan(reqData));
    setSelectedData(null);
  };

  const handleSelectedData = (id) => {
    let currentSelectedData = list_panduan.find((item) => item.id === id);
    setSelectedData(currentSelectedData);
  };
  const handleDelete = () => {
    dispatch(fetchDeletePanduan(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };

  const columnsPanduan = [
    {
      name: "id", // Kolom UUID
      label: "ID",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "nama_sop",
      label: "Judul Panduan",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "file_sop",
      label: "File Panduan",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          const fileUrl = `${BASEURL}/files/${value}`;
          return (
            <a
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1976d2", textDecoration: "underline" }}
            >
              {value}
            </a>
          );
        },
      },
    },
    {
      name: "aksi",
      label: "Aksi",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0]; // Ambil ID dari kolom pertama
          return (
            <>
              <IconButton
                color="info"
                onClick={() => {
                  handleSelectedData(id);
                  setOpenModalEditPanduan(true);
                }}
              >
                <Edit />
              </IconButton>
              <IconButton
                color="error"
                onClick={() => {
                  setOpenKonfirmasi(true);
                  handleSelectedData(id);
                }}
              >
                <Delete />
              </IconButton>
            </>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    fixedHeader: false,
    fixedSelectColumn: false,
    responsive: "standard",
    rowsPerPageOptions: [30, 60, list_panduan.length],
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
  };

  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header
          title="Panduan"
          subtitle="Daftar Panduan(SOP) yang akan dilihat di perangkat karyawan."
        />

        <Box>
          <Button
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              "&:hover": {
                backgroundColor: theme.palette.secondary.light, // Tetap sama dengan warna awal
              },
            }}
            onClick={() => setOpenAdd(true)}
          >
            <Groups2Outlined sx={{ mr: "10px" }} />
            Tambah Panduan
          </Button>
        </Box>
      </FlexBetween>
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={list_panduan}
          columns={columnsPanduan}
          options={options}
        />
        <AddPanduanModal
          open={openAdd}
          onClose={() => setOpenAdd(false)}
          onSubmit={(value) => handleSubmitPanduan(value)}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
        <KonfirmasiModal
          titleType={"Hapus"}
          subtitleType={"Menghapus"}
          dataWillProses={selectedData?.nama_sop}
          open={openKonfirmasi}
          onClose={() => setOpenKonfirmasi(false)}
          onSubmit={() => handleDelete()}
        />
        <EditPanduanModal
          open={openModalEditPanduan}
          onClose={() => setOpenModalEditPanduan(false)}
          onSubmit={(value) => handleSubmitEditPanduan(value)}
          dataEdit={selectedData}
        />
      </Box>
    </Box>
  );
};

export default Panduan;
